import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 1rem 1rem;
  background-color: ${({ theme }) => theme.colors.gray8};
`;
